export const addDaySuffix = (day: number | string) => {
  const _day = typeof day === 'string' ? parseInt(day) : day;

  let suffix;

  switch (_day % 10) {
    case 1:
      suffix = _day === 11 ? 'th' : 'st';
      break;
    case 2:
      suffix = _day === 12 ? 'th' : 'nd';
      break;
    case 3:
      suffix = _day === 13 ? 'th' : 'rd';
      break;
    default:
      suffix = 'th';
      break;
  }

  return day + suffix;
};
